/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  ClaudeHookPayload,
  ClaudeHookPayload$Outbound,
  ClaudeHookPayload$outboundSchema,
} from "../components/claudehookpayload.js";

export type HooksNumberClaudeRequest = {
  /**
   * Optional API key for plugin-driven attribution.
   */
  gramKey?: string | undefined;
  /**
   * Optional project slug for plugin-driven attribution.
   */
  gramProject?: string | undefined;
  /**
   * Optional endpoint hostname supplied by the Speakeasy hook plugin.
   */
  xGramHookHostname?: string | undefined;
  /**
   * Optional per-invocation token reused across retries so the server stores a redelivered event exactly once.
   */
  idempotencyKey?: string | undefined;
  claudeHookPayload: ClaudeHookPayload;
};

/** @internal */
export type HooksNumberClaudeRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  "X-Gram-Hook-Hostname"?: string | undefined;
  "Idempotency-Key"?: string | undefined;
  ClaudeHookPayload: ClaudeHookPayload$Outbound;
};

/** @internal */
export const HooksNumberClaudeRequest$outboundSchema: z.ZodMiniType<
  HooksNumberClaudeRequest$Outbound,
  HooksNumberClaudeRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    xGramHookHostname: z.optional(z.string()),
    idempotencyKey: z.optional(z.string()),
    claudeHookPayload: ClaudeHookPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      xGramHookHostname: "X-Gram-Hook-Hostname",
      idempotencyKey: "Idempotency-Key",
      claudeHookPayload: "ClaudeHookPayload",
    });
  }),
);

export function hooksNumberClaudeRequestToJSON(
  hooksNumberClaudeRequest: HooksNumberClaudeRequest,
): string {
  return JSON.stringify(
    HooksNumberClaudeRequest$outboundSchema.parse(hooksNumberClaudeRequest),
  );
}
